export default __webpack_public_path__ + "static/media/members-green.d90703c9.svg";